export default __webpack_public_path__ + "static/static2-img2-6e981087bd4f2fcbff268ddb772d8a86.jpg";